/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SystemAnnouncementPriority = {
    Low: 'low',
    Normal: 'normal',
    High: 'high'
} as const;
export type SystemAnnouncementPriority = typeof SystemAnnouncementPriority[keyof typeof SystemAnnouncementPriority];

